import {
  IMovementEventState,
  IMovementStartedData,
  IWorldMapEvent
} from "@/store/apis/socketRegistry"
import {
  IMovementPlan,
  IMovementStateResponse
} from "@/store/apis/worldMapAPI/worldMap.types"

const parseMs = (iso: string): number => {
  const ms = Date.parse(iso)
  if (Number.isNaN(ms)) throw new Error(`Invalid movement timestamp: ${iso}`)
  return ms
}

const toPlan = (
  m: IMovementEventState,
  lastAppliedOccurredAt: number
): IMovementPlan => {
  if (
    import.meta.env.DEV &&
    m.route[0] &&
    (m.route[0].x !== m.to.x || m.route[0].y !== m.to.y)
  ) {
    console.warn("[movement] contract invariant violated: route[0] !== to", m)
  }
  return {
    from: m.from,
    to: m.to,
    target: m.target,
    startedAtMs: parseMs(m.startedAt),
    endsAtMs: parseMs(m.endsAt),
    route: m.route,
    cancelAfterCurrentStep: m.cancelAfterCurrentStep,
    stepStraightMs: m.stepStraightMs,
    stepDiagonalMs: m.stepDiagonalMs,
    movementMode: m.movementMode,
    lastAppliedOccurredAt
  }
}

export const fromRest = (dto: IMovementStateResponse): IMovementPlan => {
  const { status: _status, ...rest } = dto
  return toPlan(rest, 0)
}

export const fromSocket = (
  event: IWorldMapEvent<IMovementStartedData>
): IMovementPlan => toPlan(event.data.movement, parseMs(event.occurredAt))
